<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    result: {
        type: Object,
        required: true
    }
})

const formattedAddress = computed(() => {
    const { label } = props.result.address;
    const highlights = props.result.highlights?.address?.label;

    if (!highlights || highlights.length === 0) {
        return label;
    }
    
    let formatted = '';
    let currentEnd = 0;
    highlights.forEach(hl => {
        // highlight are given with start and end index
        const start = hl.start;
        const end = hl.end;
        formatted += label.slice(currentEnd, start) + '<span class="highlight">'+label.slice(start, end) + '</span>'
        currentEnd = end;
    });
    formatted += label.slice(currentEnd);
    return formatted;
});
</script>
<template>
    <div class="result">
        <div class="result__address" v-html="formattedAddress"></div>
    </div>
</template>
<style>
    .highlight {
        background-color: rgba(255, 238, 0, 0.536);
    }
</style>